import Swiper from 'swiper';

new Swiper('.kn-post-list-1 .swiper-container', {
  slidesPerView: 'auto',
  freeMode: true,
  centerInsufficientSlides: true,
});

var post_type = 'case-studies', taxonomy = 'cases', page = 2, ppp = 10, shownAll = false;
$('#load-older-posts').on('click', function(e) {
    e.preventDefault();

    $(this).hide();
    $.post("https://"+window.location.hostname+"/wp-admin/admin-ajax.php", {
        action: "more_post_ajax",
        post_type,
        taxonomy,
        ppp,
        pageNumber: page,
        lang: window.wpml_current_language
    })
    .success(posts => {
        if (posts) {
          page++;
          if (ppp === -1) $("#posts-list").html(posts);
          else $("#posts-list").append(posts);
          
          filterCategory($(".filter.active a").data("cat"));
          
          checkNextPage(10, page, $(this));
        }
    });
});

// filter
$('.filter-list a').on('click', function(e) {
  e.preventDefault();
  filterCategory($(this).data('cat'), 1);
});
function filterCategory(cat, all) {
  $(".filter-list li").removeClass("active");
  if ($(".filter-list li a[data-cat='"+cat+"']").length) $(".filter-list li a[data-cat='"+cat+"']").parent().addClass("active");
  else $(".filter-list li a[data-cat='all']").parent().addClass("active");

  $('.posts-list .post').removeClass('active');
  if (cat && cat !== "all" && cat !== "") {

    $('.posts-list .post').each(function () {
      var arr = $(this).data("cat").split(",");
      if (arr.indexOf(cat) >= 0) $(this).addClass("active");
    });

  } else $('.posts-list .post').addClass('active');

  if (all && !shownAll) {
    shownAll = true;
    ppp = -1;
    $('#load-older-posts').click();
  }
}
if (getParameterByName("cat")) filterCategory(getParameterByName("cat"), 1);
else filterCategory();

function checkNextPage(ppp, page, sender) {
  $.post("https://"+window.location.hostname+"/wp-admin/admin-ajax.php", {
        action: "more_post_ajax",
        post_type,
        taxonomy,
        ppp,
        pageNumber: page,
        lang: window.wpml_current_language
    })
    .success(posts => {
      return !posts || posts === '' ? sender.hide() : sender.show();
    });
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}